export const checkLineItemsOutOfPolicy = lineItems => {
  return lineItems?.map(lineItem => ({
    ...lineItem,
    outOfPolicy: lineItem?.is_returnable_reason && lineItem?.is_returnable_reason !== 'not_enough_quantity',
  }))
}

export const isOrderOutOfPolicy = (orderReturnableReason, orderLineItems) => {
  return orderReturnableReason || orderLineItems?.some(lineItem => lineItem?.outOfPolicy)
}
